import { render } from "./StudentScopesBanner.vue?vue&type=template&id=365b6246&ts=true"
import script from "./StudentScopesBanner.vue?vue&type=script&lang=ts"
export * from "./StudentScopesBanner.vue?vue&type=script&lang=ts"

import exportComponent from "/tmp/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__